import { effectiveStatu } from '@/common/dictionary.js';
import { validRequired } from '@/common/elementValid.js';
import shadowDom from '@/components/shadowDom/shadowDom.vue';

function functionUpdate(val = {}, disabled = false, status) {
	let statusOptions = effectiveStatu;
	if (status === 'view') {
		statusOptions = effectiveStatu.concat([
			{
				label: '已关闭',
				value: 3,
			},
		]);
	}
	return {
		status: {
			label: '生效状态',
			formType: 'sky-select',
			options: statusOptions,
			disabled,
			value: val.status,
			rules: [validRequired('此项必填', 'change')],
		},
		beginTime: {
			label: '生效时间',
			formType: 'sky-date-picker',
			type: 'datetime',
			disabled,
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			value: val.beginTime,
			pickerOptions: {
				disabledDate(time) {
					let start = new Date().getTime();
					return time.getTime() < start;
				},
				// selectableRange: `${parseTime(new Date(), '{hh}:{ii}:{ss}')}-23:59:00`,
			},
			displayWith(row) {
				return row.status.value === 2 || row.status.value === 3;
			},
		},
		projectVersionNum: {
			label: '标题',
			formType: 'sky-input',
			disabled,
			placeholder: '请输入标题',
			value: val.projectVersionNum,
			rules: [validRequired('此项必填')],
		},
		shadowDom: {
			label: '更新说明',
			formType: shadowDom,
			content: val.explain,
			displayWith() {
				return status === 'view';
			},
		},
		explain: {
			label: '更新说明',
			formType: 'sky-richtext',
			placeholder: '请输入内容',
			value: val.explain,
			displayWith() {
				return status !== 'view';
			},
		},
		systemTypeList: {
			label: '发布系统',
			formType: 'sky-select',
			disabled,
			options: [
				{ label: '全球赢Web端', value: '1' },
				{ label: '全球赢小程序', value: '2' },
			],
			multiple: true,
			value: val.systemTypeList || [],
			rules: [validRequired('此项必填', 'change')],
		},
		fileList: {
			label: 'Web端系统图',
			formType: 'sky-uploadImg',
			disabled,
			value: val.fileList || [],
			// platform: 'iglobalwin-public-resource',
			judgeType: 'img',
			limit: 4,
			rules: [validRequired('此项必填', 'change')],
			displayWith(row) {
				return row.systemTypeList.value.indexOf('1') !== -1;
			},
		},
		// noticeFlag: {
		//   label: '开启公众号通知',
		//   formType: 'sky-radio',
		//   disabled,
		//   options: [
		//     {
		//       label: '是',
		//       value: 1,
		//     },
		//     {
		//       label: '否',
		//       value: 0,
		//     },
		//   ],
		//   value: val.noticeFlag,
		// },
		// content: {
		//   label: '通知内容',
		//   formType: 'sky-textarea',
		//   disabled,
		//   placeholder: '请输入内容',
		//   autosize: { minRows: 2 },
		//   maxlength: '200',
		//   'show-word-limit': true,
		//   value: val.content,
		//   displayWith(row) {
		//     return row.noticeFlag.value !== 0;
		//   },
		// },
	};
}

export default functionUpdate;
